import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/TextField": TextField, "@mui/material/Autocomplete": Autocomplete } } });
export default ClientProvider;
